
const ATTR_LIST_UPDATE_LIST = 'ATTR_LIST_UPDATE_LIST';
const ATTR_LIST_UPDATE_PAGE = 'ATTR_LIST_UPDATE_PAGE';
const ATTR_LIST_UPDATE_CONDITION = 'ATTR_LIST_UPDATE_CONDITION';
const ATTR_PROPERTYLIST_UPDATE_LIST = 'ATTR_PROPERTYLIST_UPDATE_LIST';
const ATTR_LIST_PROPER_LIST = 'ATTR_LIST_PROPER_LIST';

const AttrConfigModel = function () {
  const name = 'attrconfig_list';
  return {
    name,
    state: {
      list: [{}],
      condition: {
        propertyName: '' ,  //属性名称
        required:'',
        options:'',
        inputType:'',
        type:'',
      },
      propertyList:[
        {
            propertyName: '课时' ,  //属性名称
            required:'',
            options:'',
            inputType:'',
            type:'',
        }
    ],
      page: {
        cur_page: 1,
        size: 30,
        total: 0
      }
    },
    selectors: (state) => {
      const currentState = state[name];
      const selectors = {
        getList: () => currentState.list,
        getPage: () => currentState.page,
        getCondition: () => currentState.condition,
        getPropertyList:() => currentState.propertyList,
      };
      return selectors;
    },
    actions: {
      changeList: (list) => (dispatch, getState) => {
        dispatch({
          type: ATTR_LIST_UPDATE_LIST,
          list
        });
      },
      changePage: (page) => (dispatch, getState) => {
        dispatch({
          type: ATTR_LIST_UPDATE_PAGE,
          page
        });
      },
      changeCondition: (key, value ,index) => (dispatch, getState) => {
        dispatch({
          type: ATTR_LIST_UPDATE_CONDITION,
          key,
          value,
          index
        });
      },
      changePropertycondit: ( index,name,value ) => (dispatch, getState) => {
        dispatch({
          type: ATTR_PROPERTYLIST_UPDATE_LIST,
          index,
          name,
          value
        });
      },
      changepropertyList: (propertyList) => (dispatch, getState) => {
        dispatch({
          type: ATTR_LIST_PROPER_LIST,
          propertyList
        });
      },
    },
    reducers: {
      list: (state = AttrConfigModel.state.list, action) => {
        if (action.type === ATTR_LIST_UPDATE_LIST) {
          return [...action.list];
        }
        return state;
      },
      page: (state = AttrConfigModel.state.page, action) => {
        if (action.type === ATTR_LIST_UPDATE_PAGE) {
          return Object.assign({}, state, action.page);
        }
        return state;
      },
      condition: (state = AttrConfigModel.state.condition, action) => {
        if (action.type === ATTR_LIST_UPDATE_CONDITION) {
          const { key, value ,index} = action;
          let obj = {};
          obj[index][key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      },
      propertyList: (state = AttrConfigModel.state.propertyList, action) => {
        if (action.type === ATTR_PROPERTYLIST_UPDATE_LIST) {
          const { index,name,value ,...propertyList} = action;
          propertyList[index][name]= value ;
          return Object.assign({}, state, propertyList);
        }else if( action.type === ATTR_LIST_PROPER_LIST ){
            return [...action.propertyList];
        }else{
          return state;
        }
      },
    }
  };
}();

export default AttrConfigModel;


// WEBPACK FOOTER //
// ./src/models/AttrConfigModel.js